// IMPORTANT: import this file first in main.tsx before any other imports.
// Initialises Sentry error tracking and performance monitoring for the browser.
import * as Sentry from '@sentry/react';
import { captureRegistrationFragment } from './features/events/registration-fragment';
import { consumeViewAsFragment } from './lib/auth/view-as-bootstrap';

// A registration link (`/e/:id#r=<token>`) carries a secret in its fragment.
// Take it off the address bar BEFORE Sentry.init, so the tracing and replay
// integrations never see it in the page URL. The event page reads it from memory.
captureRegistrationFragment();
// A view-as tab (MYN-335) opens at `/view-as#<token>`: same reason, same place.
consumeViewAsFragment(window.location, window.history);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string,
  environment: (import.meta.env.VITE_APP_ENV as string) ?? 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Lower sample rates in production to control volume/cost
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: import.meta.env.PROD ? 0.05 : 0,
  // Only activate when DSN is configured (no-op in environments without it)
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});
